module.exports = __webpack_public_path__ + "img/pr-13.6174f659.png";